import React from "react";
import styles from "./Market.module.sass";
import cn from "classnames";
import Loader from "../../../components/Loader";
import Row from "./Row";
import { Pager } from "../../../components/Pager";

const Market = ({ data, setActive, ...props }) => {
	return (
		<div className={styles.market}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col}></div>
					<div className={styles.col}>Drop name</div>
					<div className={styles.col}>Products</div>
					<div className={styles.col}>Community market vol 24h</div>
					<div className={styles.col}>Owned users</div>
				</div>
				{data.map((x) => (
					<Row item={x} key={x._id} setActive={setActive} />
				))}
			</div>
			{props.isLoading && (
				<div className={styles.loaderWrap}>
					<Loader className={styles.loader} />
				</div>
			)}
			<div className={styles.foot}>
				<Pager {...props} />
			</div>
		</div>
	);
};

export default Market;
